import classNames from 'classnames'
import React from 'react'
import { isNullOrWhiteSpace } from '../../../utilities/string'
import { ContactButtons } from '../../ContactButtons'
import { Grid } from '../../Grid'
import { Image, ImageProps } from '../../Image'

export interface MarketPersonItem {
  description?: string
  email?: string
  imageProps?: ImageProps
  name?: string
  phoneNumber?: string
  workTitle?: string
}

export interface MarketContactPersonsSectionProps {
  contacts?: MarketPersonItem[]
  title?: string
}

export const MarketContactPersonsSection = ({
  contacts,
  title,
}: MarketContactPersonsSectionProps) => (
  <Grid additionalClassName="py-30 bg-shade-lightest-warm tb:py-60" as="section">
    <div
      className={classNames(
        'col-span-full flex flex-col gap-45 tb:mx-75',
        'sm:col-start-2 sm:col-span-4 sm:mx-0',
        'lg:col-start-2 lg:col-span-6',
        'xl:col-start-3 xl:col-span-6',
        'xxl:col-start-3 xxl:col-span-10'
      )}
    >
      {!isNullOrWhiteSpace(title) && (
        <h2 className="text-secondary-dark font-h2 text-h2">{title}</h2>
      )}

      {!!contacts?.length && (
        <div
          className={classNames(
            'flex flex-col mx-45 gap-45',
            'tb:grid tb:grid-cols-2 tb:gap-x-120 tb:gap-y-90 tb:mx-0',
            'lg:grid-cols-4 lg:gap-45'
          )}
        >
          {contacts.map((contact, index) => (
            <div className="flex flex-col" key={index}>
              {!!contact.imageProps && (
                <Image
                  {...contact.imageProps}
                  altText={contact.name ?? ''}
                  className="rounded-15 overflow-hidden"
                  imgClassName="w-full"
                />
              )}

              {(!isNullOrWhiteSpace(contact.name) ||
                !isNullOrWhiteSpace(contact.workTitle) ||
                !isNullOrWhiteSpace(contact.description)) && (
                <div className="flex flex-col gap-10 mt-15 first:mt-0">
                  {!isNullOrWhiteSpace(contact.name) && (
                    <h3 className="text-secondary-dark font-t text-t-500">
                      {contact.name}
                    </h3>
                  )}

                  {!isNullOrWhiteSpace(contact.workTitle) && (
                    <div className="text-secondary-darker font-t-bold text-t-400">
                      {contact.workTitle}
                    </div>
                  )}

                  {!isNullOrWhiteSpace(contact.description) && (
                    <div className="text-secondary-darker text-t-400">
                      {contact.description}
                    </div>
                  )}
                </div>
              )}

              {(!isNullOrWhiteSpace(contact.email) ||
                !isNullOrWhiteSpace(contact.phoneNumber)) && (
                <div className="mt-auto">
                  <ContactButtons
                    additionalClassName="mt-20"
                    email={contact.email}
                    name={contact.name ?? ''}
                    phone={contact.phoneNumber}
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  </Grid>
)
